'use strict';

angular.module('shiftTraderApp')
  .factory('ShiftTrades', function (ServerUrls, $http, $q) {
    var path = ServerUrls.current.railsApi + 'shift_trades/';

    var currentStatus = function (trade) {
      var sortedResponses = _.sortBy(trade.shift_trade_responses, 'created_at'); //todo check that this is newest first ordered
      var response = _.find(sortedResponses, 'acceptance_code');
      if(response && response.acceptance_code) {
        return response.acceptance_code;
      } else {
        return 0;
      }
    };

    return {
      currentStatus: currentStatus,
      rejectTrade: function (message, shiftTrade, me) { //TODO move 'me' to a service, so it can be injected
        var data =  {
          'user_id': me.id,
          'shift_trade_id': shiftTrade.id,
          'acceptance_code': 'REJECTED',
          'message': message
        };

        return $http.post(ServerUrls.current.railsApi + 'shift_trade_responses', data)
          .then(function (response) {
            return (response.data);
          }, function(response) {
            return $q.reject(response);
          });
      },

      getByWorkPeriodId: function (workPeriodId) {
        return $http.get(path, { 'work_period_id': workPeriodId })
          .then(function (response) {
            return response.data;
          }, function(response) {
            return $q.reject(response);
          });
      },
      getAll: function () {
        return $http.get(path)
          .then(function (response) {
            return response.data;
          }, function(response) {
            return $q.reject(response);
          });
      },
      createTrade: function (message, work, tradeWork) {
        var data = {
          'user_id': work.user.id,
          'work_period_id': work.id,
          'message': message,
          'trade_work_period_id': tradeWork.id,
          'trade_user_id': tradeWork.user.id,
          'organization_id': work.organization.id
        };

        return $http.post(path, data)
          .then(function (response) {
            return response.data;
          }, function(response) {
            return $q.reject(response);
          });
      }
    };
  });
